import { Component, OnInit, OnDestroy, ViewChild, Inject } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from '../../services';
import { CurrentUserModel } from '../../models/account-ledger.model';
import { ShoppingCartService } from '../../services/shopping-cart.service';
import { CheckOutService } from '../../services/checkout.service';
import { PostcodeList } from '../../models/account-delivery-address';
import { combineLatest, Subject } from 'rxjs';
import { DickerSelectListItem } from '../../models/check-out.model';
import { DOCUMENT } from '@angular/common';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from '../../services/auth.service';
import { CustomerService } from '../../services/customer.service';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-enroll-program',
  templateUrl: './enroll-program.component.html',
  styleUrls: ['./enroll-program.component.css']
})
export class EnrollProgramComponent implements OnInit, OnDestroy {

  private customerId: string;
  public displayedColumns: string[] = ['programName', 'button1', 'button2'];
  public dataSource: MatTableDataSource<any>
  public programs = [
    {
      programName: 'Microsoft CSP',
      programType: 'CSP',
      button1: 'Associate Microsoft CSP',
      button2: 'Create Tenant'
    }
  ];
  public title: string = "Enroll Program";
  public isEditMode = false;
  setFullWindow: boolean = true;
  userFormGroup: FormGroup;
  stateList: string[];
  loadContent: boolean = false;
  programType: string;
  programName: string;
  tenantId: string = '';
  companyCode: string = '';
  selectedPayment: string = '';
  paymentList: DickerSelectListItem[] = [];
  filteredPostCode: PostcodeList[];
  filteredSub: PostcodeList[];
  checkDomain: boolean = false;
  public currentUserModel: CurrentUserModel;

  //unsubscribe
  ngUnsubscribe: Subject<void> = new Subject<void>();
  constructor(
    private router: Router,
    private shoppingCartService: ShoppingCartService,
    private checkOutService: CheckOutService,
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private customerService: CustomerService,
    private commonService: CommonService,
    private authService: AuthService,
    public cs: CommonService,
    @Inject(DOCUMENT) private _document: Document
  ) {
    this.userFormGroup = this.formBuilder.group({
      userGroup: this.getUserGroup()
    });

    if (this.router.url.includes('edit-customer')) {
      this.isEditMode = true;
    }
  }

  ngOnInit() {
    this.loadContent = true;

    this.dataSource = new MatTableDataSource(this.programs);

    combineLatest([
      this.activatedRoute.parent.paramMap,
      this.customerService.currentCustomerProgramsWatch
    ])
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(([params, programs]) => {
        this.customerId = params.get('customerId');

        const programTyps = [ ...programs ].map(a => a?.programType)
        this.programs = [ ...this.programs ].filter(a => !programTyps.includes(a.programType));
        this.dataSource = new MatTableDataSource(this.programs);
      });

  }

  async ngAfterViewInit() {
    await this.cs.waitForElm('#levelOne');
    $('#levelOne').animate({ scrollLeft: $('#manage-customer').width() + 250 }, 400);
  }

  getUserGroup(): FormGroup {
    return this.formBuilder.group({
      firstNameField: new FormControl("", Validators.compose([Validators.required])),
      lastNameField: new FormControl("", Validators.compose([Validators.required])),
      emailField: new FormControl("", this.commonService.emailValidatorRegex()),
      companyNameField: new FormControl("", Validators.compose([Validators.required])),
      addressLine1Field: new FormControl("", Validators.compose([Validators.required])),
      addressLine2Field: new FormControl(""),
      addressLine3Field: new FormControl(""),
      suburbField: new FormControl("", Validators.compose([Validators.required])),
      stateField: new FormControl("", Validators.compose([Validators.required])),
      postcodeField: new FormControl("", Validators.compose([Validators.required])),
      phoneField: new FormControl("", Validators.compose([Validators.required]))
    });
  }

  getPaymentMehodList() {
    this.checkOutService.GetDigitalWallet().pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((value: DickerSelectListItem[]) => {
        this.paymentList = value;
      },
        (error: any) => {
          console.info(error);
        });
  }

  navigateToDigitalWallet() {
    this.router.navigateByUrl('/myAccount/digitalwallet?createNew=true');
  }

  navigateToDetailsPage() {
    this.router.navigate([`CSPDetailsNew/${this.tenantId}`], { relativeTo: this.activatedRoute.parent });
  }

  startFilterPostcode(res: PostcodeList[]): void {
    this.filteredPostCode = res;
  }
  startFilterSub(res: PostcodeList[]): void {
    this.filteredSub = res;
  }

  isNumberKey(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  public associateExistingEndUser(): void {
    this.router.navigate(["associateExistingEndUser"], {
      relativeTo: this.activatedRoute,
    });
  }

  public addNewTenant(): void {
    this.router.navigate(["createTenant"], {
      relativeTo: this.activatedRoute,
    });
  }


  close() {
    this.router.navigateByUrl(`/customers/${this.customerId}`);
    $('#levelOne').animate({ scrollLeft: 0 }, 400);
  }
  omit_nonprintable_char(event: any) {    
    event.target.value = this.commonService.omit_nonprintable_char(event.target.value);
    if (event.target.id == "addressLine1") {
      this.userFormGroup.get('userGroup.addressLine1Field').setValue(event.target.value);
    }
    else if (event.target.id == "addressLine2") {
      this.userFormGroup.get('userGroup.addressLine2Field').setValue(event.target.value);
    }
    else if (event.target.id == "addressLine3") {
      this.userFormGroup.get('userGroup.addressLine3Field').setValue(event.target.value);
    }
  }
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
